import { useCallback } from "react";
import { FRAME_STEP_SECONDS } from "../constants";
import { useVideoControl } from "../contexts/VideoControlContext";

const frameStepSeconds = (videoFps: number | null): number =>
  videoFps ? 1 / videoFps : FRAME_STEP_SECONDS;

export const useSkipAndStepHandlers = ({
  skipSeconds,
  ceilingSeconds,
}: {
  skipSeconds: number;
  ceilingSeconds?: number;
}) => {
  const { state, actions } = useVideoControl();
  const stepSeconds = frameStepSeconds(state.videoFps);

  const handleSkipBackward = useCallback(() => {
    actions.seekTo(actions.getLiveCurrentTime() - skipSeconds);
  }, [actions, skipSeconds]);

  const handleSkipForward = useCallback(() => {
    actions.seekTo(actions.getLiveCurrentTime() + skipSeconds, ceilingSeconds);
  }, [actions, skipSeconds, ceilingSeconds]);

  const handleStepBackward = useCallback(() => {
    actions.pause();
    actions.seekTo(actions.getLiveCurrentTime() - stepSeconds);
  }, [actions, stepSeconds]);

  const handleStepForward = useCallback(() => {
    actions.pause();
    actions.seekTo(actions.getLiveCurrentTime() + stepSeconds, ceilingSeconds);
  }, [actions, stepSeconds, ceilingSeconds]);

  return {
    handleSkipBackward,
    handleSkipForward,
    handleStepBackward,
    handleStepForward,
  };
};
